<div class="dialog-container">
  <h1 mat-dialog-title>¿Desea cerrar sesión?</h1>
  <div mat-dialog-content>
    <img src="/assets/images/doggie-play.png" alt="cerrar sesión">
  </div>
  <div mat-dialog-actions>
    <button mat-button class="btn__secondary" [mat-dialog-close]="false">Cancelar</button>
    <button mat-button class="btn__primary" [mat-dialog-close]="true" cdkFocusInitial>Cerrar Sesión</button>
  </div>
</div>